import React from 'react'
import ProgressBar from '../progressBar/progressBar'

export default ({ urlState, displayImages, year, make, model, images, nextDisabled, errorFunc, updateGlobalState, trim, autoCheckData, vinResults, experienceState, globalState, mileage }) => {
  return (
    <ProgressBar {...{ urlState, year, make, model, trim, nextDisabled, errorFunc, updateGlobalState, autoCheckData, vinResults, experienceState, globalState, mileage }} />
  )
}
